/**
 * @file The 1-based page of a spreadsheet pricebook edition that one parsed
 * sheet becomes: its sheet index plus one, or its position among the parsed
 * table chunks plus one when the chunk does not name a sheet. Shared so the
 * server writing the page and S4 showing the sheet's rows agree on which
 * sheet a page is. Consumers: `runEnvisionPricebook` and S4's
 * `loadSpreadsheetSheet`.
 */
import type { TableChunk } from './System.Agent.Extraction.types';

export function pricebookSheetPage(table: Pick<TableChunk, 'source'>, index: number): number {
    return table.source.kind === 'sheet' ? table.source.index + 1 : index + 1;
}
